const allUsers = {
    users: []
  };
  
  export default allUsers;